module.exports = __webpack_public_path__ + "static/img/countryharvest.ed78913.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/countryharvest.png
// module id = JVs3
// module chunks = 0